import { currentLang, pick } from "@kit/lang";

const STRINGS = {
  title: { tr: "Yankı", en: "Echo" },
  topTitle: { tr: "Yankı · {n}", en: "Echo · {n}" },
  // Screen-reader instructions for the canvas (TR = the page's meta description in yanki/index.html).
  instructions: {
    tr: "Yankı: dört simgenin sırasını dinle ve tekrarla. Ters yankı seviyelerinde sondan başa gir. Zaman baskısı yok; 1–4 tuşlarıyla veya dokunarak oyna.",
    en: "Echo: listen to the order of four symbols and repeat it. On reverse echo levels, enter it from last to first. No time pressure; play with keys 1–4 or by tapping.",
  },
  roundLabel: { tr: "TUR", en: "ROUND" },
  padSun: { tr: "Güneş", en: "Sun" },
  padWave: { tr: "Dalga", en: "Wave" },
  padMoon: { tr: "Ay", en: "Moon" },
  padStar: { tr: "Yıldız", en: "Star" },
  controls: { tr: "Dokun veya 1–4 tuşlarını kullan · sayaç yok", en: "Tap or use keys 1–4 · no timer" },
  length: { tr: "{len} İŞARET", en: "{len} SYMBOLS" },
  reverse: { tr: "←  TERS YANKI  ·  sondan başa", en: "←  REVERSE ECHO  ·  last to first" },
  forward: { tr: "İLERİ YANKI  →", en: "FORWARD ECHO  →" },
  progress: { tr: "Ücretsiz tekrar: {replays}", en: "Free replays: {replays}" },
  readyStatus: { tr: "Hazır olduğunda diziyi dinle.", en: "Listen when you're ready." },
  readyDetail: { tr: "İşaretleri duyduğun sırayla tekrarla.", en: "Repeat the symbols in the order you hear them." },
  readyReverse: {
    tr: "Bu seviye TERS: duyduğun diziyi sondan başa gir. İlk dokunuş, en son çalan işaret.",
    en: "This level is REVERSE: enter what you hear from last to first. Your first tap is the last symbol played.",
  },
  reverseNew: { tr: "YENİ: Ters Yankı", en: "NEW: Reverse Echo" },
  listen: { tr: "Diziyi dinle", en: "Listen" },
  showingStatus: { tr: "Dikkatle dinle…", en: "Listen closely…" },
  showingReverse: { tr: "Sonra SONDAN BAŞA tekrarla.", en: "Then repeat it LAST TO FIRST." },
  showingForward: { tr: "Sonra aynı sırayla tekrarla.", en: "Then repeat it in the same order." },
  playing: { tr: "Dizi çalıyor…", en: "Playing…" },
  inputStatus: { tr: "Sıra sende", en: "Your turn" },
  inputReverse: { tr: "Sıra sende · sondan başa ←", en: "Your turn · last to first ←" },
  inputDetail: { tr: "{typed} / {len} işaret doğru", en: "{typed} / {len} symbols right" },
  listenAgain: { tr: "Yeniden dinle", en: "Listen again" },
  mistakeStatus: { tr: "Karıştı. Hiçbir şey kaybetmedin.", en: "Mixed up. Nothing lost." },
  mistakeDetail: { tr: "Bu turu istediğin kadar ücretsiz yeniden dinle.", en: "Replay this round for free as often as you like." },
  mistakeReverse: { tr: "Ters sıraydı: en son duyduğun işaretten başla.", en: "It was reverse: start with the last symbol you heard." },
  freeReplay: { tr: "Ücretsiz tekrar", en: "Free replay" },
  successStatus: { tr: "Güzel dinledin · Tur {round} tamam!", en: "Well listened · Round {round} done!" },
  successDetail: { tr: "Bir sonraki turda dizi bir işaret uzayacak.", en: "Next round, the sequence grows by one symbol." },
  oneMore: { tr: "Sonraki tur", en: "Next round" },
  won: { tr: "Tamam!", en: "Done!" },
  wonSub: { tr: "Seviye {n} · {len} işaretlik dizi · {replays} tekrar", en: "Level {n} · {len}-symbol sequence · {replays} replays" },
  share: { tr: "Paylaş", en: "Share" },
  skip: { tr: "Seviyeyi atla (ücretsiz)", en: "Skip level (free)" },
  shareText: { tr: "Yankı · Seviye {n}: {len} işaretlik diziyi hatırladım. Sen de dene!", en: "Echo · Level {n}: I remembered a {len}-symbol sequence. Your turn!" },
  shareTitle: { tr: "Yankı — Enjoyment", en: "Echo — Enjoyment" },
} as const;

export type Key = keyof typeof STRINGS;
export function t(key: Key, vars: Record<string, string | number> = {}): string {
  return pick(currentLang(), STRINGS[key]).replace(/\{(\w+)\}/g, (_m, k: string) => String(vars[k] ?? ""));
}
